import { track } from '@mc/track-event'
import { CheckoutEvents } from '../../lib/constants'
import { SocialVendorLogInInitiatedEventProps } from '../../types/SocialVendorLogInInitiatedEventProps'

export const trackSocialVendorLogInInitiated = ({
  pageSource,
  vendor,
  modalType,
}: SocialVendorLogInInitiatedEventProps) => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN_INITIATED, {
    location: 'falcon_cart',
    page_source: pageSource,
    social_sign_on_vendor: vendor,
    ...(modalType && { modal_type: modalType }),
  })
}
